module.exports = function getResource(label, vars = []) {
    let resources = {
        selectCurrent: 'Select your current shade for'
    };

    return resources[label];
};
